import { validateGridSearch } from "@/components/composite/data-grid";
import { createFileRoute } from "@tanstack/react-router";
import { EvaluationPage } from "./-evaluation/evaluation.page";

export const Route = createFileRoute("/content/evaluation/")({
  validateSearch: validateGridSearch,
  component: EvaluationPage,
});
